<!-- Camera Capture Modal -->
@if (isVisible()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4">
  <div class="camera-modal-container relative w-full max-w-2xl bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col" style="aspect-ratio: 1; max-height: 90vh; width: min(90vw, 600px);">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200">
      <h3 class="text-lg font-semibold text-gray-900">
        {{ capturedImage() ? 'Review Photo' : 'Capture Photo' }}
      </h3>
      <button
        type="button"
        (click)="cancel()"
        class="text-gray-400 hover:text-gray-600 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="camera-modal-content relative bg-gray-900 flex-1" style="width: 100%;">
      <!-- Loading State -->
      @if (loading()) {
      <div class="absolute inset-0 flex flex-col items-center justify-center text-white">
        <svg class="animate-spin h-12 w-12 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm">Starting camera...</p>
      </div>
      }

      <!-- Error State -->
      @if (error()) {
      <div class="absolute inset-0 flex flex-col items-center justify-center text-white px-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-16 h-16 mb-4 text-red-400">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        <p class="text-center text-sm mb-2 font-medium">{{ error() }}</p>
        <p class="text-center text-xs text-gray-400">Please check your browser settings and try again.</p>
      </div>
      }

      <!-- Video Preview (Live Camera) -->
      @if (!loading() && !error() && !capturedImage()) {
      <video
        #videoElement
        autoplay
        playsinline
        class="w-full h-full object-cover"
      ></video>
      }

      <!-- Captured Image Preview -->
      @if (capturedImage()) {
      <img
        [src]="capturedImage()"
        alt="Captured photo"
        class="w-full h-full object-contain"
      />
      }

      <!-- Hidden Canvas for capture -->
      <canvas #canvasElement class="hidden"></canvas>

      <!-- Camera Overlay (Guides) -->
      @if (!loading() && !error() && !capturedImage()) {
      <div class="absolute inset-0 pointer-events-none">
        <!-- Corner guides -->
        <div class="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-white opacity-50"></div>
        <div class="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-white opacity-50"></div>
        <div class="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-white opacity-50"></div>
        <div class="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-white opacity-50"></div>
      </div>
      }
    </div>

    <!-- Actions -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-200">
      @if (!loading() && !error()) {
        @if (!capturedImage()) {
        <!-- Capture State -->
        <div class="flex items-center justify-center gap-4">
          <app-action-button
            [label]="'Cancel'"
            [variant]="'outline'"
            (clicked)="cancel()"
            [buttonClass]="'!px-6 !py-2 !rounded-lg'"
          ></app-action-button>
          
          <button
            type="button"
            (click)="capturePhoto()"
            class="relative w-12 h-12 rounded-full bg-white border-2 border-[#6729FF] hover:border-[#5520DD] transition-all duration-200 flex items-center justify-center group shadow-lg hover:shadow-xl"
          >
            <div class="w-8 h-8 rounded-full bg-[#6729FF] group-hover:bg-[#5520DD] transition-colors"></div>
          </button>
        </div>
        } @else {
        <!-- Review State -->
        <div class="flex items-center justify-center gap-4">
          <app-action-button
            [label]="'Retake'"
            [variant]="'outline'"
            (clicked)="retakePhoto()"
            [buttonClass]="'!px-6 !py-2 !rounded-lg'"
          ></app-action-button>
          
          <app-action-button
            [label]="'Use Photo'"
            [variant]="'filled'"
            (clicked)="savePhoto()"
            [buttonClass]="'!px-4 !py-2.5 !rounded-lg !bg-[#6729FF] hover:!bg-[#5520DD] !text-white !font-medium !shadow-md hover:!shadow-lg !transition-all'"
          ></app-action-button>
        </div>
        }
      } @else {
        <!-- Error/Loading State -->
        <div class="flex items-center justify-center">
          <app-action-button
            [label]="'Close'"
            [variant]="'outline'"
            (clicked)="cancel()"
            [buttonClass]="'!px-8 !py-2 !rounded-lg'"
          ></app-action-button>
        </div>
      }
    </div>
  </div>
</div>
}

